var html = $('.products_custom_slide').find('ul').html();
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0,'',this.dataset.variant,this.dataset.otherVariant,this.dataset.sleeve);
    });
    $('.product_cart_recommendation').hide();
    setTimeout(function() {
    sliderCode();
    }, 1000);
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
class CartItems extends HTMLElement {
 constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
       this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index, 
      event.target.value, 
      document.activeElement.getAttribute("name"),
      event.target.dataset.variant,
      event.target.dataset.otherVariant,
      event.target.dataset.sleeve
    );
  }

  getSectionsToRender() {
    return [
      { id: 'main-cart-items', section: document.getElementById('main-cart-items').dataset.id, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-icon-bubble-mobile', section: 'cart-icon-bubble-mobile', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      { id: 'main-cart-footer', section: document.getElementById('main-cart-footer').dataset.id, selector: '.js-contents' }
    ];
  }

  updateQuantity(line, quantity, name, variantID, otherVariant,has_sleeve) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then(state => { 
        const parsedState = JSON.parse(state);

        // Scenario 1 & 2: Sync sleeve quantity only when main product is updated
        if (otherVariant !== '') {
          this.syncAssociatedItems(parsedState, parseInt(variantID), quantity, parseInt(otherVariant),has_sleeve);
        }

        this.updateCartUI(parsedState, line, name);
      })
      .catch(() => {
        this.handleCartError();
      });
  }

  syncAssociatedItems(cartState, updatedItemVariantId, updatedQuantity, otherVariant,has_sleeve) {
    const cartItems = cartState.items;
    let associatedVariantId = null;
    let variantKey=null;
    let variantQuantity=null;
    // Identify associated product based on main product properties
    cartItems.forEach((item) => {
      if (item.variant_id === updatedItemVariantId) {
        associatedVariantId = item.properties?._Sleeve_variant_id || item.properties?._Main_variant_id;
      }
     if (item.variant_id === otherVariant) {
        variantKey=item.key;
        variantQuantity=item.quantity;
     }
    });

    let associatedItem = cartItems.find(item => item.variant_id == associatedVariantId);
    console.log(associatedItem,"has_sleeve",has_sleeve)
    if (has_sleeve == "true") {
    if(updatedQuantity ==0){    this.updatePropertyToBlank(variantKey,variantQuantity); }
      // ✅ Scenario 2 Fix: Do NOT update main product if sleeve quantity changes
      return;
    }

    if (associatedItem) {
      // ✅ Scenario 1: Increase sleeve quantity when main product increases
      this.modifyProductQuantity(associatedItem.variant_id, updatedQuantity);
    } else {
      // ✅ Scenario 3: If sleeve is removed, make the property value empty instead of deleting it
      //this.updatePropertyToBlank(updatedItemVariantId);
    }
  }

updatePropertyToBlank(variantId,variantQuantity) {
    fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            id: variantId,  // Corrected JSON syntax
            quantity:variantQuantity,
            properties: { 
                "_Sleeve_variant_id": "",  // Make this blank
                "Sleeve_product": ""       // Make this blank
            },
            sections: this.getSectionsToRender().map(section => section.section),
            sections_url: window.location.pathname
        })
    })
    .then(response => response.text())
    .then(state => {
        const parsedState = JSON.parse(state);
        this.updateCartUI(parsedState);
    })
    .catch(error => console.error("Error updating property value to blank:", error));
}


  modifyProductQuantity(variantId, quantity) {
    fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            updates: { [variantId]: quantity },
            sections: this.getSectionsToRender().map(section => section.section),
            sections_url: window.location.pathname
        })
    })
    .then(response => response.text())
    .then(state => { 
      const parsedState = JSON.parse(state);
      this.updateCartUI(parsedState);
    })
    .catch(error => console.error("Error updating quantity:", error));
  }

  updateCartUI(parsedState, line = null, name = null) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach(section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });

    if (line) {
      this.updateLiveRegions(line, parsedState.item_count);
      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      }
    }
    
    this.disableLoading();
  }

  handleCartError() {
    this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    errors.textContent = window.cartStrings.error;
    this.disableLoading();
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};




// function sliderInit() {
//   $(document).find('.slider-drawer_new').slick({
//     dots: false,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 1,
//     adaptiveHeight: true,
//     prevArrow: '<div class="img-arrow-left drawer-left-slider"><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4848 0.46787L18.5453 6.51729C18.9172 6.88852 18.9172 7.49039 18.5453 7.86161L12.4848 13.911C12.1128 14.2823 11.5099 14.2823 11.138 13.911C10.7661 13.5398 10.7661 12.9379 11.138 12.5667L15.5728 8.14003H0.464844V6.23888H15.5728L11.138 1.81219C10.7661 1.44096 10.7661 0.839093 11.138 0.46787C11.5099 0.0966474 12.1128 0.0966474 12.4848 0.46787Z" fill="#404040"></path></svg></div>',
//     nextArrow: '<div class="img-arrow-right top drawer-slider" ><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4848 0.46787L18.5453 6.51729C18.9172 6.88852 18.9172 7.49039 18.5453 7.86161L12.4848 13.911C12.1128 14.2823 11.5099 14.2823 11.138 13.911C10.7661 13.5398 10.7661 12.9379 11.138 12.5667L15.5728 8.14003H0.464844V6.23888H15.5728L11.138 1.81219C10.7661 1.44096 10.7661 0.839093 11.138 0.46787C11.5099 0.0966474 12.1128 0.0966474 12.4848 0.46787Z" fill="#404040"></path></svg></div>'
//   });
// }

// function sliderCode() {
//     $('.products_custom_slide').html('');

//     setTimeout(function() {
//   $('.products_custom_slide').html(html);


//   var array_of_Cart_items = [];
//   $.getJSON('/cart.js', function(cart) {
//     var count = cart.item_count;
//     var items = cart.items;
//     console.log(items);

//    cart.items.forEach(function(item) {
//         // Access product variant ID for each item
//         var variantID = item.variant_id;
//         console.log('Product Variant ID:', variantID);
//       array_of_Cart_items.push(variantID);
//     });

//     // for (var i = 0; i < count; i++) {
//     //   var item_id = items[i].variant_id;
      
//     //   array_of_Cart_items.push(item_id);
//     // }
   
//   });

 
//      setTimeout(function() {

//     // $('.slider-drawer_new').slick('unslick');
//     $('.drawer_slide-slide').show();
//     $('.drawer_slide-slide').each(function() {
//       var ths = $(this);
//       var id = parseInt($(this).attr('data-id'));
//       if (jQuery.inArray(id, array_of_Cart_items) !== -1) {
//         console.log('in array ' + id);
//         ths.remove();
//       }
      
//     });

//     sliderInit();

//     $('.product_cart_recommendation').show();
//     var Slidescount = $('.slider-drawer_new .slick-slide').length;
//      if (Slidescount === 0) {
//       $('.heading_like_Also').hide();
//     }
//        }, 1000);
//   }, 1000);
  
// }

function sliderInit() {
   $('.slider-drawer_new').not('.slick-initialized').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    prevArrow: '<div class="img-arrow-left drawer-left-slider"><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4848 0.46787L18.5453 6.51729C18.9172 6.88852 18.9172 7.49039 18.5453 7.86161L12.4848 13.911C12.1128 14.2823 11.5099 14.2823 11.138 13.911C10.7661 13.5398 10.7661 12.9379 11.138 12.5667L15.5728 8.14003H0.464844V6.23888H15.5728L11.138 1.81219C10.7661 1.44096 10.7661 0.839093 11.138 0.46787C11.5099 0.0966474 12.1128 0.0966474 12.4848 0.46787Z" fill="#404040"></path></svg></div>',
    nextArrow: '<div class="img-arrow-right top drawer-slider" ><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4848 0.46787L18.5453 6.51729C18.9172 6.88852 18.9172 7.49039 18.5453 7.86161L12.4848 13.911C12.1128 14.2823 11.5099 14.2823 11.138 13.911C10.7661 13.5398 10.7661 12.9379 11.138 12.5667L15.5728 8.14003H0.464844V6.23888H15.5728L11.138 1.81219C10.7661 1.44096 10.7661 0.839093 11.138 0.46787C11.5099 0.0966474 12.1128 0.0966474 12.4848 0.46787Z" fill="#404040"></path></svg></div>'
  });
}

function sliderCode() {
    // Fetch cart data asynchronously
  $('.products_custom_slide').find('ul').html('');
  $('.products_custom_slide').find('ul').html(html);
  
    $.getJSON('/cart.js')
    .done(function(cart) {
        var array_of_Cart_items = [];

        // Process cart items
        cart.items.forEach(function(item) {
            var variantID = item.variant_id;
            array_of_Cart_items.push(variantID);
        });

        // Wait until products_custom_slide element is available
        var checkExist = setInterval(function() {
            if ($('.products_custom_slide').length) {
                clearInterval(checkExist);

                // Filter and initialize slider once products_custom_slide is available
                $('.drawer_slide-slide').each(function() {
                    var ths = $(this);
                    var id = parseInt($(this).attr('data-id'));
                    if (jQuery.inArray(id, array_of_Cart_items) !== -1) {
                        console.log('in array ' + id);
                        ths.remove();
                    }
                });

                sliderInit();

                $('.product_cart_recommendation').show();
                var Slidescount = $('.slider-drawer_new .slick-slide').length;
                if (Slidescount === 0) {
                    $('.heading_like_Also').hide();
                }
            }
        }, 100); // Check every 100ms
    })
    .fail(function(error) {
        console.error('Error fetching cart data:', error);
    });
}



// $(document).ready(function() {
//     sliderCode();
// });